import classnames from 'classnames';
import React, { PureComponent } from 'react';

const CSS = require('./Banner.module.less');

interface BannerButton {
  label: string;
  onClick: () => void;
  isDefault?: boolean;
  className?: string;
}

interface BannerProps {
  children: string | JSX.Element | JSX.Element[];
  buttons?: BannerButton[];
  className?: string;
  onRender?: () => void;
}

let singleton;

class Banner extends PureComponent<BannerProps> {
  componentWillMount() {
    if (!singleton) {
      singleton = this;
    }
  }

  componentWillUnmount() {
    if (singleton === this) {
      singleton = null;
    }
  }

  renderButtons() {
    const { buttons = [] } = this.props;

    return (
      <div className={CSS.ControlBar}>{buttons.map(this.renderButton)}</div>
    );
  }

  renderButton(button: BannerButton, index = 0) {
    return (
      <button
        key={`${button.label}_${index}`}
        className={classnames(
          CSS.Button,
          { [CSS.DefaultButton]: button.isDefault },
          button.className,
        )}
        onClick={button.onClick}
      >
        {button.label}
      </button>
    );
  }

  render() {
    if (singleton === this) {
      const { children, className, onRender } = this.props;
      onRender && onRender();
      return (
        <section className={classnames(CSS.Banner, className)}>
          <div className={CSS.Text}>{children}</div>
          {this.renderButtons()}
        </section>
      );
    }
    return null;
  }
}

export default Banner;
